module.exports = __webpack_public_path__ + "img/方块中级大师@2x.da6466b6.png";